function Rating(props) {
  const rating = Array(Math.floor(props.rating)).fill('');

  return (
    <div className="rating">
      <ul className="rating__list">
        {rating.map((star, index) => {
          return (
            <li key={`star-${index}`} className="rating__item"><i key={`${index}-star`} className="icon-star-rating" /></li>
          );
        })}
      </ul>


      {props.showRating && (<span className="rating__span">{props.rating} </span>)}
    </div>
  );
}

export default Rating;
